<template>
    <div>
        <popup-component></popup-component>
        <banner-component></banner-component>
        <div class="content homenews_title">
            <div class="news_title">뉴스</div>
            <button class="news_icon" @click="movePage('/news')"></button>
        </div>
        <div class="homenews_border"></div>
        <board-home-component :boardType="`homeNews`"></board-home-component>

        <div class="content donatenews">
            <div class="donatenews_title">
                <div class="donatenews_title">나눔&배움</div>
                <button class="donatenews_icon" @click="movePage('/donate')"></button>
            </div>
        </div>
        <div class="homenews_border"></div>

        <board-home-component :boardType="`homeDonate`"></board-home-component>

        <member-home-component :memberType="`homeMember`"></member-home-component>
    </div>
</template>

<script>
    // @ is an alias to /src

    import BoardHomeComponent from "@/components/board/BoardHomeComponent";
    import MemberHomeComponent from "@/components/member/MemberHomeComponent";
    import BannerComponent from "@/components/banner/BannerComponent";
    import PopupComponent from "@/components/popup/PopupComponent";

    export default {
        name: 'Home',
        mixins: [],
        components: {PopupComponent, BannerComponent, MemberHomeComponent, BoardHomeComponent},
        props: {},
        data() {
            return {}
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            movePage(url) {
                this.$router.push(url)
            }
        },
        watch: {},
    }
</script>
